export default function DropinPreview({src}){
    return (
        <div
        style={{
            display: 'flex',
            justifyContent: 'center'
        }}>
            <img
                src={src}
                style={{
                    width: '100%',
                    maxWidth: '400px',
                    objectFit: 'contain'
                }}/>
        </div>
    )
}